import { FormattedMessage } from 'react-intl';
import { isEmpty } from 'lodash';

import './style.scss';

const STATUS_CLASS: Record<string, string> = {
  Available: 'available',
  Redeemed: 'redeemed',
  Expired: 'expired',
};

interface IProps {
  status?: string;
}

export function RewardStatus(props: IProps) {
  const { status } = props;
  if (isEmpty(status)) return null;

  const normalized = (status ?? '').trim();
  const className =
    STATUS_CLASS[normalized] ??
    (normalized.toLowerCase() === 'available'
      ? 'available'
      : normalized.toLowerCase() === 'redeemed'
        ? 'redeemed'
        : normalized.toLowerCase() === 'expired'
          ? 'expired'
          : 'default');

  return (
    <div className="reward-status">
      <div className={`reward-status__box ${className}`}>
        <FormattedMessage id={`rewards.status.${className}`} defaultMessage={normalized} />
      </div>
    </div>
  );
}
